import React, { useEffect, useState } from "react";
import PublicHeader from "../components/header";
import { useLocation, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import APIService from "../components/postServices";
import { Dialog } from "primereact/dialog";
import { Card } from "primereact/card";

const breadcrumb = [
  { label: "Entrance Exam Result", url: "/entranceExamResult" },
];

function EntranceExamResult() {
  const navigate = useNavigate();
  const location = useLocation();
  const [currentAcademicYear, setCurrentAcademicYear] = useState(null);

  useEffect(() => {
    APIService.get(`/EnquiryApplications/CurrentAcademicYearRegistration`)
      .then((response) => {
        setCurrentAcademicYear(response.data.dataSet);
      })
      .catch((error) => {
        // Handle API call errors here
        console.error("Error:", error);
      });
  }, []);

  const [paymentSuccess, setpaymentSuccess] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const params = new URLSearchParams(location.search);
  const status = params.get("status");
  const bank_ref_no = params.get("bank_ref_no");
  const amount = params.get("amount");
  const orderId = params.get("orderId");

  const tracking_id = params.get("tracking_id");

  useEffect(() => {
    if (status === "Success") {
      setpaymentSuccess(true);
      setSuccess(true);
    } else if (status === "Failure") {
      setpaymentSuccess(false);
      setSuccess(true);
    } else if (status === "Aborted") {
      setpaymentSuccess(false);
      setSuccess(true);
    } else if (status === "Completed") {
      setpaymentSuccess(false);
      setSuccess(false);
    } else {
      setSuccess(false);
    }
  }, [status]);

  const hideDialog = () => {
    setSuccess(false);

    // navigate("/entranceExamResult", { replace: true });
    window.location.replace("http://stjudesonline.in");
  };

  const header = (
    <>
      <i
        className={
          paymentSuccess === true ? "pi pi-check-circle" : "pi pi-times-circle"
        }
        style={{
          fontSize: "2.5rem",
          color: paymentSuccess === true ? "green" : "red",
        }}
      ></i>
    </>
  );
  const footer = (
    <div className="flex flex-wrap justify-content-end gap-2">
      <Button
        label="Ok"
        // size="small"
        severity="info"
        onClick={hideDialog}
      />
    </div>
  );

  // const [currentAcademicYear, setCurrentAcademicYear] = useState();
  const [selectedClass, setSelectedClass] = useState(null);

  const [classListArray, setClassListArray] = useState(null);

  useEffect(() => {
    currentAcademicYear &&
      APIService.get(
        `/Masters/DistinctClassSelectionProcesses?academicYearFilter=${currentAcademicYear}`
      )
        .then((response) => {
          setClassListArray(response.data.dataSet);
        })
        .catch((error) => {
          // Handle API call errors here
          console.error("Error:", error);
        });
  }, [currentAcademicYear]);

  const [UserformData, setFormData] = useState({
    applicationNo: "",
  });

  console.log("selectedClass", selectedClass);

  const [resultData, setResultData] = useState({});

  const [UserformError, setFormError] = useState({});
  const [error, setError] = useState(false);

  const AppNoChange = (e) => {
    setFormData({ ...UserformData, [e.target.name]: e.target.value });
  };

  const handleError = (error, input) => {
    setFormError((prevState) => ({ ...prevState, [input]: error }));
    setError(true);
  };

  const GetResultByAPPNo = async (e) => {
    e.preventDefault();
    setSelectedClass("");
    setResultData({});
    let isValid = true;
    let applicationNo = UserformData.applicationNo;
    if (!applicationNo) {
      handleError("Please insert an Application No", "applicationNo");
      isValid = false;
    }

    if (isValid) {
      try {
        const response = await APIService.get(
          `/SelectionProcess/ResultGetByClassAndAppNo?academicYear=${currentAcademicYear}&applicationNo=${applicationNo}`
        );
        if (response.data.responseCode === 1) {
          setResultData(response.data.dataSet);
        }
      } catch (error) {
        console.error("Error fetching company data:", error);
      }
    }
  };

  const GetResultByClass = async (e) => {
    e.preventDefault();
    setFormData({});
    setResultData({});
    setFormError({});
    let isValid = true;
    let classCode = selectedClass && selectedClass.code;
    if (!classCode) {
      handleError("Please select a class", "classCode");
      isValid = false;
    }
    if (isValid) {
      try {
        const response = await APIService.get(
          `/SelectionProcess/ResultGetByClassAndAppNo?academicYear=${currentAcademicYear}&class=${classCode}`
        );
        if (response.data.responseCode === 1) {
          setResultData(response.data.dataSet);
        }
      } catch (error) {
        console.error("Error fetching company data:", error);
      }
    }
  };

  // Create a Set to store unique class values
  const uniqueClasses = new Set();

  // Create an array of unique class objects
  const uniqueClassObjects =
    classListArray &&
    classListArray.reduce((acc, item) => {
      if (!uniqueClasses.has(item.class)) {
        uniqueClasses.add(item.class);
        acc.push({ class: `class ${item.class}`, code: item.class });
      }
      return acc;
    }, []);

  const formatGender = (rowData) => {
    return rowData.gender === 1 ? "Male" : rowData.gender === 2 ? "Female" : "";
  };

  const payOnline = (data) => {
    navigate("/RegPay", {
      state: { data: data },
    });
  };
  const pamentTemplate = (rowData) => {
    return (
      <button
        className="btn btn-danger btn-sm"
        onClick={() => payOnline(rowData)}
        // style={{ width: "250px" }}
      >
        Pay online
      </button>
    );
  };

  return (
    <div className="main-page">
      <PublicHeader breadcrumb={breadcrumb} title={"Entrance Exam Result"} />
      <div className="content-wrapper mt-10">
        <div className="col-md-12">
          <div className="text-center">
            <h3>
              ENTRANCE EXAM RESULTS FOR ACADEMIC YEAR {currentAcademicYear}
            </h3>
            <h5>
              The official email with further details of completion of the
              admission will be sent to you shortly.
            </h5>
          </div>
          <br />
          <div className="row">
            <div className="col-12 md:col-12 xl:col-6">
              <div className="row">
                <div className="col-12 md:col-6 xl:col-4">
                  <p style={{ margin: "0px", fontSize: "1.3 rem" }}>
                    Find an Application No
                  </p>
                </div>
                <div className="col-12 md:col-6 xl:col-4">
                  <InputText
                    type="text"
                    id="applicationNo"
                    // className="p-inputtext-sm"
                    value={UserformData.applicationNo}
                    onChange={AppNoChange}
                    onFocus={() => handleError(null, "applicationNo")}
                    placeholder="APP12345"
                    name="applicationNo"
                    // onBlur={whenRollIdBlur}
                    style={{ width: "100%" }}
                  />
                  {error && UserformError.applicationNo && (
                    <div className="text-red">
                      {UserformError.applicationNo}
                    </div>
                  )}
                </div>
                <div className="col-12 md:col-6 xl:col-4">
                  <Button onClick={GetResultByAPPNo}>Find</Button>
                </div>
              </div>
            </div>
            <div className="col-12 md:col-12 xl:col-6">
              <div className="row">
                <div className="col-12 md:col-6 xl:col-4">
                  <p style={{ margin: "0px", fontSize: "1.3 rem" }}>
                    or Select a class to view result
                  </p>
                </div>
                <div className="col-12 md:col-6 xl:col-4">
                  <Dropdown
                    value={selectedClass}
                    onChange={(e) => setSelectedClass(e.value)}
                    options={uniqueClassObjects}
                    optionLabel="class"
                    placeholder="Select a Class"
                    className="w-full"
                  />
                  {error && UserformError.classCode && (
                    <div className="text-red">{UserformError.classCode}</div>
                  )}
                </div>
                <div className="col-12 md:col-6 xl:col-4">
                  <Button onClick={GetResultByClass}>Find</Button>
                </div>
              </div>
            </div>
          </div>
          <br />
          <div className="col-md-12">
            <DataTable
              value={resultData}
              showGridlines
              size={"small"}
              tablestyle={{ minWidth: "50rem" }}
            >
              <Column field="applicationNo" header="App.No"></Column>
              <Column
                field="name"
                header="Name"
                // body={formatName}
              ></Column>
              <Column
                field="gender"
                header="Gender"
                body={formatGender}
              ></Column>
              <Column header="" body={pamentTemplate}></Column>
            </DataTable>
          </div>
        </div>
      </div>

      <Dialog
        // maximizable
        visible={success}
        style={{ width: "40vw", background: "#ff6358" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Payment Result"
        modal
        className="p-fluid "
        onHide={hideDialog}
      >
        <br />
        <div className="row  justify-content-center">
          <div className=" flex text-center">
            <Card
              // title={paymentSuccess === true ? "Success" : "Failed"}
              title={
                status === "Success"
                  ? "Success"
                  : status === "Failure"
                  ? "Failed"
                  : status === "Aborted"
                  ? "Cancelled"
                  : ""
              }
              // subTitle="Subtitle"
              footer={footer}
              header={header}
              className="md:w-30rem"
              style={{ boxShadow: "none" }}
            >
              <h4 className="m-0">
                {paymentSuccess === true
                  ? "Payment completed successfully"
                  : "Transaction unsuccessful"}
              </h4>
              <p>
                {status === "Success"
                  ? "Thank you! You will soon receive notifications on WhatsApp and via email. For any further queries, please email us at sjps@stjudesonline.in or feel free to contact us directly at 04266 275709 / 04266 275809."
                  : status === "Failure"
                  ? "Apologies, but your transaction has not been approved. If you have any concerns or questions, please feel free to reach out us directly at 04266 275709 / 04266 275809 or please email us at sjps@stjudesonline.in"
                  : status === "Aborted"
                  ? "If you have any concerns or questions, please feel free to reach out us directly at 04266 275709 / 04266 275809 or please email us at sjps@stjudesonline.in"
                  : ""}
              </p>
              <p className="" style={{ fontSize: "medium" }}>
                {orderId && `Order Id : ${orderId}`}
              </p>
              <p className="" style={{ fontSize: "medium" }}>
                {tracking_id === 0 ? " " : `Transaction Id : ${tracking_id}`}
              </p>
              <p className="" style={{ fontSize: "medium" }}>
                {amount === 0 ? " " : `Amount : INR ${amount}`}
              </p>
            </Card>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default EntranceExamResult;
